export default "__VITE_ASSET__CVrg8mwy__";